module.exports = __webpack_public_path__ + "img/live.62b33596.png";